import { Lock } from 'lucide-react';
import { Link } from 'react-router-dom';

/**
 * Locked Video Overlay — shown when accessLevel is 'subscriber' and user is NOT enrolled.
 * Displays the imgbb thumbnail blurred with a padlock and subscribe CTA.
 */
export default function LockedOverlay({ thumbnailUrl, courseId }) {
  return (
    <div className="relative rounded-2xl overflow-hidden aspect-video bg-slate-900 select-none"
      onContextMenu={(e) => e.preventDefault()}>
      {/* Blurred thumbnail background */}
      {thumbnailUrl ? (
        <img
          src={thumbnailUrl}
          alt="محتوى مقفل"
          className="absolute inset-0 w-full h-full object-cover blur-lg scale-110 opacity-60"
          draggable={false}
        />
      ) : (
        <div className="absolute inset-0 bg-gradient-to-br from-slate-800 to-slate-950" />
      )}

      {/* Dark overlay */}
      <div className="absolute inset-0 bg-black/50" />

      {/* Center content */}
      <div className="relative z-10 flex flex-col items-center justify-center h-full gap-5 px-6 text-center">
        {/* Lock icon with glow */}
        <div className="relative">
          <div className="absolute inset-0 bg-primary-600/30 rounded-full blur-2xl scale-150" />
          <div className="relative w-20 h-20 rounded-full bg-white/10 backdrop-blur-xl border border-white/20 flex items-center justify-center shadow-2xl">
            <Lock className="w-9 h-9 text-white" />
          </div>
        </div>

        {/* Text */}
        <div>
          <h3 className="text-xl font-black text-white mb-2">هذا الفيديو مخصص للمشتركين فقط</h3>
          <p className="text-mdtext-white/70 font-medium max-w-xs mx-auto">
            سجّل الآن في العائلة الإبداعية للحصول على وصول كامل لكل الدروس والمحتويات.
          </p>
        </div>

        {/* CTA */}
        <Link
          to={`/courses/${courseId}`}
          className="px-8 py-3.5 bg-primary-600 text-white font-bold rounded-xl shadow-[0_0_25px_rgba(230,0,35,0.5)] hover:shadow-[0_0_35px_rgba(230,0,35,0.7)] hover:-translate-y-0.5 transition-all"
        >
          اشترك لفتح المحتوى
        </Link>
      </div>
    </div>
  );
}
